import { Colors } from "@blueprintjs/core";
import styled from "styled-components";

const HeaderStyle = styled.div`
  background-color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.DARK_GRAY2 : Colors.LIGHT_GRAY5};
  border-radius: 3px 3px 0 0;
  padding: 20px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.DARK_GRAY5 : Colors.LIGHT_GRAY1};
  color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.LIGHT_GRAY5 : Colors.DARK_GRAY2};
`;

export default HeaderStyle;
